<style scoped lang="scss">
.detail{
  margin-bottom: 20px;
}
</style>

<template>
  <el-drawer size="600" v-model="drawShow" class='submitDrawer' :closeOnClickModal="false">
    <template #header="{ titleId, titleClass }">
      <h4 :id="titleId" :class="titleClass">
        {{ drawerTitle }}
        <span v-if="!(refund_refuse||loook_refund)"><i class="icon-time"></i>{{ state.contTimeTxt }}</span>
      </h4>
    </template>
    <div v-if="loook_refund" class="title top">{{state.refundDetailObj.refund_record.title}}</div>
    <template v-if="loook_refund">
      <div class="detail">
        <div class="column" v-for="(item,idx) in state.refundDetailObj.refund_record.items" :key="idx">
          <label>{{item.name}}</label>
          <p>{{item.value}}</p>
        </div>
      </div>
    </template>
    <div v-if="loook_refund" class="title top">退款申请记录</div>
    <template v-if="!loook_refund">
      <template v-if="state.refund_node == 0 && !refund_refuse">
        <p>项目众筹期间，支持者有权随时取消支持订单并申请退款。您可以在倒计时结束前：</p>
        <p style="padding: 8px 0 17px 0">
          1.主动联系用户，协商取消退款。<br>
          2.点击“同意退款申请”按钮，系统将立即执行退款。<br>
          3.不做任何操作，系统将在倒计时结束后自动执行退款。<br>
        </p>
      </template>
      <template v-if="state.refund_node == 1 && !refund_refuse">
        <p>项目众筹成功后，若回报发放延期或可能延期，发起者应及时发布更新公告说明延期原因和预期发放日期，如有支持者因此要求退款，发起者应与支持者友好协商并妥善处理退款申请。您可以在倒计时结束前：</p>
        <p style="padding: 8px 0 17px 0">
          1.主动联系用户，协商取消退款。<br>
          2.点击“同意退款申请”按钮，系统将立即执行退款。<br>
          3.不做任何操作，系统将在倒计时结束后自动退款。<br>
          4.点击“拒绝退款”后，支持者可以要求摩点介入，摩点有权根据情况自行判断是否向支持者退款，该部分退款金额将从可结算金额中扣除。<br>

        </p>
      </template>
    </template>
    <div class="detail">
      <div class="column">
        <label>订单号</label>
        <p>{{ state.refundDetailObj.order_id }}</p>
      </div>
      <div class="column">
        <label>订单状态</label>
        <p>{{ state.refundDetailObj.order_status_name }}</p>
      </div>
      <div class="column">
        <label>档位名称</label>
        <p>{{ state.refundDetailObj.reward_title }}</p>
      </div>
      <div class="column">
        <label>退款金额</label>
        <p>¥{{ state.refundDetailObj.refund_price }}</p>
      </div>
      <div class="column">
        <label>收件人姓名</label>
        <p>{{ state.refundDetailObj.address_name }}</p>
      </div>
      <div class="column">
        <label>收件人手机号</label>
        <p>{{ state.refundDetailObj.address_mobile }}</p>
      </div>
      <div class="column">
        <label>退款理由</label>
        <p>{{ state.refundDetailObj.apply_reson }}</p>
      </div>
      <div class="column">
        <label>申请时间</label>
        <p>{{ state.refundDetailObj.ctime }}</p>
      </div>
    </div>
    <div v-if="refund_refuse" class="title">拒绝退款理由 <span class="required">*</span></div>
    <el-input v-if="refund_refuse" v-model="reason" type="textarea" maxlength="200" placeholder="请填写拒绝理由"
      show-word-limit />
    <template #footer>
      <el-button v-if="refund_refuse" type="" @click.stop="openBtn('refund_refuse')">拒绝退款申请</el-button>
      <template v-else>
        <el-button v-for="(item, btnIndex) in state.refundDetailObj.btns" :key="btnIndex"
          :type="item.type === 'refund_pass' ? 'primary' : ''" @click.stop="openBtn(item.type)">{{ item.title
          }}</el-button>
      </template>

    </template>
  </el-drawer>
</template>

<script>

export default {
  name: 'drawRefund',
  data() {
    return {
      drawShow: true,
      reason: ''
    }
  },
  components: {
  },
  watch: {
    drawShow: {
      handler() {
        this.dialogBack()
      }
    }
  },
  computed: {},
  props: ['show', 'state', 'refund_refuse', 'drawerTitle', 'loook_refund'],
  mounted() {
    this.$nextTick(() => { })
  },
  methods: {
    dialogBack() {
      this.$emit('dialogBack')
    },
    openBtn(type) {
      const obj = {
        type,
      }
      if (this.refund_refuse) {
        obj.reason = this.reason
      }
      this.$emit('openBtn', obj)
    }
  }
}
</script>
